import { getDataMapper, mapField } from "@/shared";

export const mapPromocodeToServer = getDataMapper(
    {
        code: mapField("code"),
        discount: mapField("discount", Number),
        count: mapField("count", Number),
        expires_at: mapField("expiresAt"),
        group_of_user_id: mapField("groupOfUserId", (value) => {
            return value ? Number(value) : null;
        }),
    },
    {
        shouldAvoidUndefined: true,
    },
);
